import React, {
  useEffect,
  useState
} from "react"

import axios from "axios"
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom"
import {
  getFoodImageUrl,
  getHyderabadPincodeArea,
  getPincodeLocation,
  getStoredLimitedDeliveryPincode,
  getStockQuantity,
  isHyderabadPincode,
  normalizeCategory,
  normalizePincode,
  saveStoredLimitedDeliveryPincode
} from "../utils/foodAvailability"

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  useMapEvents
} from "react-leaflet"

import "leaflet/dist/leaflet.css"
import L from "leaflet"

delete L.Icon.Default.prototype._getIconUrl

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png"
})

const API = "https://food-backend-9733.onrender.com"

const Checkout = () => {
  const [cart, setCart] = useState([])
  const [total, setTotal] = useState(0)
  const [msg, setMsg] = useState("")
  const [locationLoading, setLocationLoading] = useState(false)
  const [pincodeLookupLoading, setPincodeLookupLoading] =
    useState(false)
  const [pincodeLocation, setPincodeLocation] = useState(null)
  const storedLimitedPincode =
    getStoredLimitedDeliveryPincode()

  const [position, setPosition] =
    useState([17.385, 78.4867])

  const [data, setData] = useState({
    country: "India",
    state: "",
    city: "",
    pincode: storedLimitedPincode,
    landmark: "",
    address: "",
    phone: "",
    latitude: "",
    longitude: "",
    payment_method: "COD"
  })

  const navigate = useNavigate()

  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  const loadCart = () => {
    axios.get(`${API}/cart`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      setCart(res.data)

      let sum = 0

      res.data.forEach(item => {
        sum += Number(item.price) * Number(item.quantity)
      })

      setTotal(sum)
    })
    .catch(err => console.log(err))
  }

  useEffect(() => {
    loadCart()
  }, [])

  const handleChange = (e) => {
    const value =
      e.target.name === "pincode"
        ? normalizePincode(e.target.value)
        : e.target.value

    setData({
      ...data,
      [e.target.name]: value
    })
  }

  useEffect(() => {
    const pincode = normalizePincode(data.pincode)

    if (pincode.length !== 6) {
      setPincodeLocation(null)
      return
    }

    let ignore = false

    const loadPincodeLocation = async () => {
      setPincodeLookupLoading(true)

      const location = await getPincodeLocation(pincode)

      if (ignore) return

      setPincodeLookupLoading(false)
      setPincodeLocation(location)

      if (!location) return

      if (location.isHyderabad) {
        saveStoredLimitedDeliveryPincode(pincode)
      }

      setData(prev => {
        if (normalizePincode(prev.pincode) !== pincode) {
          return prev
        }

        return {
          ...prev,
          country: location.country || prev.country || "India",
          state: location.state || prev.state,
          city: location.city || prev.city,
          landmark:
            prev.landmark ||
            location.area ||
            prev.landmark
        }
      })
    }

    loadPincodeLocation()

    return () => {
      ignore = true
    }
  }, [data.pincode])

  const fillAddressFromLatLng = async (lat, lng) => {
    try {
      const res = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`
      )

      const addressData = res.data.address || {}

      setData(prev => ({
        ...prev,
        latitude: lat,
        longitude: lng,
        country: addressData.country || "India",
        state: addressData.state || "",
        city:
          addressData.city ||
          addressData.town ||
          addressData.village ||
          addressData.suburb ||
          addressData.county ||
          "",
        pincode: addressData.postcode || "",
        address:
          res.data.display_name ||
          prev.address
      }))

      setMsg("Location and address filled successfully")
    } catch (err) {
      console.log(err)

      setData(prev => ({
        ...prev,
        latitude: lat,
        longitude: lng
      }))

      setMsg("Location captured. Please fill address manually.")
    }
  }

  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported")
      return
    }

    setLocationLoading(true)
    setMsg("")

    navigator.geolocation.getCurrentPosition(
      async (positionData) => {
        const lat = positionData.coords.latitude
        const lng = positionData.coords.longitude

        setPosition([lat, lng])

        await fillAddressFromLatLng(lat, lng)

        setLocationLoading(false)
      },
      () => {
        setLocationLoading(false)
        alert("Unable to fetch location. Please allow location permission.")
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      }
    )
  }

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        const lat = e.latlng.lat
        const lng = e.latlng.lng

        setPosition([lat, lng])
        fillAddressFromLatLng(lat, lng)
      }
    })

    return (
      <Marker position={position}>
        <Popup>
          Delivery Location
        </Popup>
      </Marker>
    )
  }

  const RecenterMap = () => {
    const map = useMap()

    useEffect(() => {
      map.setView(position, 16)
    }, [position, map])

    return null
  }

  const placeOrder = () => {
    const unavailableItem = cart.find(item =>
      Number(item.is_out_of_stock) === 1 ||
      (
        getStockQuantity(item) !== null &&
        getStockQuantity(item) <= 0
      ) ||
      Number(item.is_expired) === 1
    )

    if (unavailableItem) {
      setMsg(
        `${unavailableItem.name} is out of stock. Please remove it from cart.`
      )
      return
    }

    if (
      !data.country ||
      !data.state ||
      !data.city ||
      !data.pincode ||
      !data.address ||
      !data.phone
    ) {
      setMsg("Please fill all delivery details")
      return
    }

    if (
      hasHyderabadOnlyItems &&
      !isHyderabadPincode(data.pincode)
    ) {
      setMsg(
        "Order not available. 48 Hours and Weekly items are delivered only to Hyderabad pincodes."
      )
      return
    }

    axios.post(
      `${API}/order`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then(res => {
      setMsg(res.data.msg)
      setCart([])
      setTotal(0)
      window.dispatchEvent(new Event("srilekha-cart-updated"))

      setTimeout(() => {
        navigate("/orders")
      }, 1200)
    })
    .catch(err => {
      console.log(err)

      setMsg(
        err.response?.data?.msg ||
        "Order failed"
      )
    })
  }

  const hasUnavailableItems = cart.some(item =>
    Number(item.is_out_of_stock) === 1 ||
    (
      getStockQuantity(item) !== null &&
      getStockQuantity(item) <= 0
    ) ||
    Number(item.is_expired) === 1
  )

  const hasHyderabadOnlyItems = cart.some(item =>
    ["48hours", "weekly"].includes(
      normalizeCategory(item.category)
    )
  )

  const deliveryArea = getHyderabadPincodeArea(data.pincode)
  const pincodeComplete = data.pincode.length === 6
  const pincodeLocationLabel =
    deliveryArea
      ? `${deliveryArea}, Hyderabad`
      : pincodeLocation
        ? [
            pincodeLocation.area,
            pincodeLocation.city,
            pincodeLocation.state,
            pincodeLocation.country
          ].filter(Boolean).join(", ")
        : ""
  const isHyderabadDelivery =
    !hasHyderabadOnlyItems ||
    Boolean(deliveryArea)

  return (
    <div className="checkout-page">

      <div className="checkout-hero">
        <span>Premium Checkout</span>
        <h1>Confirm your homemade food order</h1>
        <p>
          Review your cart, verify delivery location and complete your order.
        </p>

        <div className="checkout-hero-badges">
          <b>Fresh batch</b>
          <b>Location verified</b>
          <b>Order tracking</b>
        </div>
      </div>

      <div className="checkout-layout">

        <div className="checkout-left">

          <div className="checkout-card">
            <div className="checkout-card-head">
              <div>
                <span>Step 01</span>
                <h2>Order Summary</h2>
              </div>

              <b>{cart.length} items</b>
            </div>

            {cart.map(item => (
              <div
                key={item.id}
                className="checkout-item"
              >
                <img
                  src={getFoodImageUrl(item, API)}
                  alt={item.name}
                  onError={(e) => {
                    e.currentTarget.src = "/logo192.png"
                  }}
                />

                <div>
                  <h3>{item.name}</h3>
                  <p>Size: {item.selected_size || "250g"}</p>
                  <p>Qty: {item.quantity}</p>
                  <p>₹ {item.price}</p>

                  {(Number(item.is_out_of_stock) === 1 ||
                    (
                      getStockQuantity(item) !== null &&
                      getStockQuantity(item) <= 0
                    ) ||
                    Number(item.is_expired) === 1) && (
                    <p className="checkout-stock-warning">
                      Out of stock
                    </p>
                  )}
                </div>

                <b>
                  ₹ {Number(item.price) * Number(item.quantity)}
                </b>
              </div>
            ))}

            <div className="checkout-total">
              <span>Total Amount</span>
              <h2>₹ {total}</h2>
            </div>
          </div>

          <div className="checkout-card">
            <div className="checkout-card-head">
              <div>
                <span>Step 02</span>
                <h2>Delivery Location</h2>
                <p>
                  Use current location or tap on the map for exact delivery.
                </p>
              </div>
            </div>

            <button
              onClick={getCurrentLocation}
              className="location-btn"
              disabled={locationLoading}
            >
              {locationLoading
                ? "Fetching Location..."
                : "Use Current Location"}
            </button>

            <div className="checkout-map">
              <MapContainer
                center={position}
                zoom={15}
                style={{
                  height: "100%",
                  width: "100%"
                }}
              >
                <TileLayer
                  attribution='&copy; OpenStreetMap'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <RecenterMap />
                <LocationMarker />
              </MapContainer>
            </div>

            <p className="map-note">
              Tip: You can also tap on the map to select exact delivery location.
            </p>
          </div>

        </div>

        <div className="checkout-right">

          <div className="checkout-card">
            <div className="checkout-card-head">
              <div>
                <span>Step 03</span>
                <h2>Delivery Details</h2>
                <p>
                  Add complete address details for smooth delivery.
                </p>
              </div>
            </div>

            {hasHyderabadOnlyItems && (
              <div
                className={
                  isHyderabadDelivery
                    ? "checkout-location-rule"
                    : "checkout-location-rule warning"
                }
              >
                <b>
                  {
                    deliveryArea
                      ? "Order Available"
                      : pincodeLookupLoading
                        ? "Checking Location..."
                      : pincodeComplete
                        ? "Order Not Available"
                        : "Hyderabad pincode required"
                  }
                </b>

                <span>
                  {
                    deliveryArea
                      ? pincodeLocationLabel
                      : pincodeLookupLoading
                        ? "Fetching city, state and country..."
                      : pincodeComplete
                        ? pincodeLocationLabel
                          ? `${pincodeLocationLabel} - Not delivered to this location`
                          : "Location not found for this pincode"
                        : "48 Hours and Weekly items are Hyderabad-only."
                  }
                </span>
              </div>
            )}

            <div className="checkout-form-grid">
              <label>
                Country
                <input
                  type="text"
                  name="country"
                  placeholder="India"
                  value={data.country}
                  onChange={handleChange}
                />
              </label>

              <label>
                State
                <input
                  type="text"
                  name="state"
                  placeholder="Telangana"
                  value={data.state}
                  onChange={handleChange}
                />
              </label>

              <label>
                City
                <input
                  type="text"
                  name="city"
                  placeholder="Hyderabad"
                  value={data.city}
                  onChange={handleChange}
                />
              </label>

              <label>
                Pincode
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength="6"
                  name="pincode"
                  placeholder="500001"
                  value={data.pincode}
                  onChange={handleChange}
                />
              </label>

              <label className="checkout-field-full">
                Nearby Landmark
                <input
                  type="text"
                  name="landmark"
                  placeholder="Apartment, street or landmark"
                  value={data.landmark}
                  onChange={handleChange}
                />
              </label>

              <label className="checkout-field-full">
                Full Delivery Address
                <textarea
                  name="address"
                  placeholder="House number, street, area and complete delivery instructions"
                  value={data.address}
                  onChange={handleChange}
                  rows="4"
                />
              </label>

              <label>
                Phone Number
                <input
                  type="text"
                  name="phone"
                  placeholder="Mobile number"
                  value={data.phone}
                  onChange={handleChange}
                />
              </label>

              <label>
                Payment Method
                <select
                  name="payment_method"
                  value={data.payment_method}
                  onChange={handleChange}
                >
                  <option value="COD">
                    Cash on Delivery
                  </option>
                </select>
              </label>
            </div>

            <button
              onClick={placeOrder}
              className="place-order-btn"
              disabled={
                hasUnavailableItems ||
                (
                  hasHyderabadOnlyItems &&
                  !isHyderabadDelivery
                )
              }
            >
              Place Order
            </button>

            {msg && (
              <p className="checkout-msg">
                {msg}
              </p>
            )}
          </div>

        </div>

      </div>
    </div>
  )
}

export default Checkout
